function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4-4h24v24H-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#898B91",
  d: "M.333 11h15.334c.16 0 .295.114.326.266l.007.067V13.5a1.502 1.502 0 01-1.5 1.5.167.167 0 00-.158.114l-.009.053v.333a.5.5 0 01-.992.09l-.008-.09v-.167a.333.333 0 00-.266-.326L13 15H3a.333.333 0 00-.327.266l-.006.067v.167a.5.5 0 01-.992.09l-.008-.09v-.333A.167.167 0 001.5 15a1.502 1.502 0 01-1.493-1.356L0 13.5v-2.167c0-.16.114-.295.266-.326L.333 11h15.334zM1.51 4.333h12.98c.138 0 .258.084.309.208l.019.064.992 5.334a.333.333 0 01-.255.386l-.073.008H.517a.333.333 0 01-.334-.321l.006-.073.992-5.334a.333.333 0 01.26-.265l.068-.007H14.49zM13.167 0a1.502 1.502 0 011.5 1.5v1.833c0 .184-.15.334-.334.334h-1.05a.333.333 0 01-.33-.279l-.24-1.443a.333.333 0 00-.329-.278h-3.05A.333.333 0 009 2v1.333c0 .184-.15.334-.333.334H7.333A.333.333 0 017 3.333V2a.333.333 0 00-.333-.333H3.616a.333.333 0 00-.33.278l-.24 1.443a.333.333 0 01-.329.279h-1.05a.333.333 0 01-.334-.334V1.5a1.502 1.502 0 011.5-1.5z"
}));

function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}

export default SvgBed;